<template>
    <v-alert
        v-if="html"
        :border="border"
        colored-border
        :icon="icon"
        elevation="2"
        :class="`alerttop ${classes}`"
        v-html="html"
    ></v-alert>
    <v-alert
        v-else
        :border="border"
        colored-border
        :icon="icon"
        elevation="2"
        :class="`alerttop ${classes}`"
    >
        <slot></slot>
    </v-alert>
</template>

<script>
import { VAlert } from 'vuetify/lib';

export default {
    components: { VAlert },
    props: {
        border: {
            type: String,
            default: "bottom"
        },
        icon: {
            type: String,
            default: "fas fa-exclamation-triangle"
        },
        classes: {
            type: String,
            default: ""
        },
        codeHtml: {
            type: [String, Boolean],
            default: false
        }
    },
    data() {
        return {
            borderAlertColor: "",
            iconAlertColor: "",
            bgAlertColor: "",
            html: false
        }
    },
    created() {
        this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');    
        this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');    
        this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');   
    },
    mounted() {
        document.querySelectorAll(".alerttop").forEach(x => { x.setAttribute("style", "background:"+this.bgAlertColor); });
        document.querySelectorAll(".v-alert__icon").forEach( x => { x.setAttribute("style", "color: "+this.iconAlertColor)});
        document.querySelectorAll(".v-alert__border").forEach( x => { x.setAttribute("style", "color: "+this.borderAlertColor)});  
        if(this.codeHtml) {
            this.html = `
            <div class="v-alert__wrapper">
                <i aria-hidden="true" class="v-icon notranslate v-alert__icon fas fa-exclamation-triangle theme--light" style="color: ${this.iconAlertColor}"></i>
                <div class="v-alert__content">${this.codeHtml}</div>
                <div class="v-alert__border v-alert__border--bottom v-alert__border--has-color" style="color: ${this.borderAlertColor}"></div>
            </div>
            `;
        }
    }
}
</script>